import React from "react"

export default function SubTtitle({ text }: { text: string }) {
   return <h1 className='m-0 font-semibold text-base'>{text}</h1>
}
